<span
  [class.disabled]="controlDisabled"
  [class.label-required]="controlRequired"
  [class.ng-invalid]="controlInvalid"
  [class.ng-dirty]="controlInvalid"
  class="tw:whitespace-nowrap tw:cursor-pointer label-text {{ styleClass() }}"
>
  {{ label() }}
</span>

@if (exclamationMessage()) {
  <span
    class="tw:flex tw:items-center tw:justify-center tw:mb-2"
    [pTooltip]="exclamationMessage()"
  >
    <pinnakl-icon
      name="exclamation-mark"
      class="tw:flex tw:w-4 tw:h-4 tw:text-bluegray-600"
    />
  </span>
}
